

export interface Company {
  id: number,
  name: string
}

export interface UserCompany {
  id: number,
  companyId: number,
  userId: number
}
